import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import Select from 'react-select';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import { getApi, postApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


function InvoiceSum() {

    const navigate = useNavigate();
    const location = useLocation();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [EditIsOpen, setEditIsOpen] = useState(false);
    const [quary, setQuary] = useState("");
    const [filterData, setFilterData] = useState([]);
    const [invoice, setInvoice] = useState([]);
    const [Summary, setSummary] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [openRow, setOpenRow] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [getCustomer, setGetCustomer] = useState([]);
    const extrectArray = (response) => {
        if (Array.isArray(response?.data)) return response.data;
        if (Array.isArray(response?.Data)) return response.Data;
        return [];
    }
    const handleFormChange = (value, key) => {
        setFormData({ ...formData, [key]: value })
    }
    
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [formData, setFormData] = useState({
        fromDate: firstDayOfMonth,
        toDate: today,
        customer: "",
        invoiceNo: "",
    });
   
    useEffect(() => {
        if (getCustomer.length === 0) return;

        const login = JSON.parse(localStorage.getItem("Login"));

        if (login?.UserType === "Admin") {
            setFormData(prev => ({
                ...prev,
                customer: "ALL CLIENT DATA",
            }));
        } else {
            const customer = getCustomer.find(
                c => c.Customer_Code === login?.Customer_Code
            );
            
                setFormData(prev => ({
                    ...prev,
                    customer: login?.Customer_Code,
                }));
            


        }
    }, [getCustomer]);

   
    
   
    

    


    const fetchData = async (endpoint, setData) => {
        try {
            const response = await getApi(endpoint);
            console.log("API Response for", endpoint, response);  // 👀 Check here
            setData(extrectArray(response));
        } catch (err) {
            console.error('Fetch Error:', err);

        }
    };



 
    


  const loginCustomerCode = JSON.parse(localStorage.getItem("Login"))?.Customer_Code;
    const allOptions =
        JSON.parse(localStorage.getItem("Login"))?.UserType === "Admin"
            ?
            [
                { label: "ALL CLIENT DATA", value: "ALL CLIENT DATA" },
                ...getCustomer.map((cust) => ({
                    label: cust.Customer_Name,
                    value: cust.Customer_Code,
                })),
            ]
            :
            Array.isArray(getCustomer) && getCustomer.length > 0
                ? getCustomer
                    .map(cust => ({
                        label: cust.Customer_Name,
                        value: cust.Customer_Code,
                    }))
                : []



    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("Login"));
        fetchData(`/Master/getCustomerdata?Branch_Code=${user?.Branch_Code}&Customer_Code=${user?.Customer_Code}`, setGetCustomer);
    }, []);
 

    // Save whenever it changes
   
   const [hasSearched, setHasSearched] = useState(false);

const fetchSalesReport = async (page = currentPage) => {
    try {
        setLoading(true);

        const payload = {
            InvoiceNos: formData.invoiceNo || "",
            BillFrom: formData.fromDate?.toISOString().split("T")[0] || "",
            BillTO: formData.toDate?.toISOString().split("T")[0] || "",
            CustomerName:
                getCustomer.find(
                    f => f.Customer_Code === formData.customer
                )?.Customer_Name || "",
            Location_Code:
                JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
            pageSize: rowsPerPage,
            pageNumber: page,
        };

        const response = await postApi("/Smart/getSalesReport", payload);

        if (response?.status === 1) {
            setInvoice(response.Data);
            setSummary(response.Summary);
            setTotalRecords(response.TotalRecords);
        }
    } catch (err) {
        console.error(err);
    } finally {
        setLoading(false);
    }
};

const handleSubmit = async (e) => {
    e?.preventDefault();

    if (currentPage !== 1) {
        setCurrentPage(1); // useEffect will call API
        return;
    }

    await fetchSalesReport(); // direct call
};

useEffect(() => {
    fetchSalesReport();
}, [currentPage, rowsPerPage]);
    const totalPages = Math.ceil(totalRecords / rowsPerPage);


      const handleExportExcel = () => {
    if (invoice.length === 0) {
        return Swal.fire({
            icon: "warning",
            title: "Warning",
            text: "No Data to Export."
        });
    }

    const exportData = invoice.map((row) => ({
        "Branch Name": row.Branch_Name,
        "Customer Name": row.Customer_Name,
        "Gst No": row.GstNo,
        "Invoice No": row.InvoiceNo,
        "Invoice Date": row.InvDate,
        "Qty": row.Qty,
        "Amount": row.Amount,
        "CGST": row.CGST,
        "SGST": row.SGST,
        "IGST": row.IGST,
        "Total Amount": row.GrandTotal
    }));

    // Add Summary Row
    if (Summary && Object.keys(Summary).length > 0) {
        exportData.push({
            "Branch Name": "",
            "Customer Name": "",
            "Invoice No": "",
            "Invoice Date": "",
            "Qty": "TOTAL",
            "Amount": Summary.TotalTaxable,
            "CGST": Summary.TotalCGST,
            "SGST": Summary.TotalSGST,
            "IGST": Summary.TotalIGST,
            "Total Amount": Summary.GrandTotal
        });
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Data Report");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    });

    saveAs(blob, "SalesData_Report.xlsx");
};

    /**************** function to export table data in excel and pdf ************/
    // Handle changing page
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };
    
    
    

    return (
        <>

            <div className="body">
                <div className="container1">
                    <form  onSubmit={(e) => e.preventDefault()}>
                        <div className="fields2">
                            <div className="input-field1">
                                <label htmlFor="">Customer</label>
                                <Select
                                    options={allOptions}
                                    value={
                                        formData.customer
                                            ? allOptions.find(c => c.value === formData.customer)
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            customer: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                    placeholder="Select Customer"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                />

                            </div>
                            <div className="input-field3">
                                <label htmlFor="">From</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.fromDate}
                                    onChange={(date) => handleFormChange(date, "fromDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="">To</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.toDate}
                                    onChange={(date) => handleFormChange(date, "toDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>

                            {/* <div className="input-field2">
                                <label htmlFor="">Invoice No</label>
                                <input type="text" className="input" placeholder="Invoice No" value={formData.invoiceNo} onChange={(e) => handleFormChange(e.target.value, "invoiceNo")} />
                            </div> */}
                            <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft: "10px" }}>
                                <button className="ok-btn" onClick={handleSubmit}>Submit</button>
                                <button className="ok-btn" type="button" onClick={handleExportExcel}>Excel</button>
                            </div>
                            
                            
                        </div>
                    </form>
                    <div style={{ width: "100%", display: "flex", justifyContent: "end", marginTop: "10px" }}>


                    </div>
                    {loading ? (<div className="loader"></div>) : (
                        <div className='table-container' style={{ margin: "0px" }}>
                            <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                                <thead className="table-sm">
                                    <tr>
                                        
                                        <th className="w-60">Sr.No</th>
                                     
                                        <th className="w-60">Branch Name</th>
                                        <th>Customer Name</th>
                                        <th>Gst No</th>
                                        <th>Invoice No</th>
                                        <th>Invoice Date</th>
                                        <th>Qty</th>
                                        <th>Amount</th>
                                        <th>CGST</th>
                                        <th>SGST</th>
                                        <th>IGST</th>
                                        <th>Total Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoice.map((row, index) => (
                                        <tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                            {/* Actions */}
                                            

                                            {/* Data columns */}
                                            <td className="w-60">{index + 1}</td>
                                            <td className="w-60">{row.Branch_Name}</td>
                                            <td>{row.Customer_Name}</td>
                                            <td>{row.GstNo}</td>
                                            <td>{row.InvoiceNo}</td>
                                            <td>{row.InvDate}</td>
                                            <td>{row.Qty}</td>
                                            <td>{row.Amount}</td>
                                            <td>{row.CGST}</td>
                                            <td>{row.SGST}</td>
                                            <td>{row.IGST}</td>
                                            <td>{row.GrandTotal}</td>
                                        </tr>

                                    ))}
                                    {Summary && Object.keys(Summary).length > 0 && (
  <tr>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>{Summary.TotalTaxable}</td>
    <td>{Summary.TotalCGST}</td>
    <td>{Summary.TotalSGST}</td>
    <td>{Summary.TotalIGST}</td>
    <td>{Summary.GrandTotal}</td>
  </tr>
)}
                                </tbody>
                            </table>

                        </div >)
                    }

                    <div className="row" style={{ whiteSpace: "nowrap" }}>
            <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
              <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                {'<'}
              </button>
              <span style={{ color: "#333", padding: "5px" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                {'>'}
              </button>
            </div>

            <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
              <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}

                style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
              >
                <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
              </select>
            </div>
          </div>
                    
                    

                </div>
            </div>

        </>
    );
};

export default InvoiceSum;